var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, customElement, html, property, css } from 'lit-element';
let DarkModeButton = class DarkModeButton extends LitElement {
    constructor() {
        super();
        this.isDark = false;
    }
    toggleMode() {
        this.isDark = !this.isDark;
        document.documentElement.classList.toggle('is-dark');
    }
    render() {
        return html `
      <button @click=${this.toggleMode.bind(this)} class="c-button" type="button" aria-label="Toggle dark mode">
        ${this.isDark ?
            html `<slot name="moon"></slot>` :
            html `<slot name="sun"></slot>`}
      </button>
    `;
    }
};
DarkModeButton.styles = css `
    button {
      background: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 2.5rem;
      padding: 0.25rem;
      width: 2.5rem;
    }
  `;
__decorate([
    property({ type: Boolean })
], DarkModeButton.prototype, "isDark", void 0);
DarkModeButton = __decorate([
    customElement('dark-mode-button')
], DarkModeButton);
export { DarkModeButton };
